import React from "react";
import Header from "../../components/header/Header";
import "./About.css";

const About = () => {
  return (
    <div>
      <Header text="ABOUT" />
      <h2 className="home-heading">THE TEAM BEHIND CRIME UNFOLDED</h2>
      <p className="about-para">
        Welcome to Crime Unfolded - an exciting venture born from the strong
        bond of friendship that has united us since grade 7. As a group of best
        friends, we shared countless experiences and cherished memories
        together. Now, as we've grown older, we wanted to create something
        unique and captivating, bringing our shared passion to life. One fateful
        day, during a casual gathering, we stumbled upon a game that sparked our
        imagination and creativity. Inspired by this experience, we knew we
        wanted to embark on a thrilling journey together, and that's when Crime
        Unfolded was born. Our mission was clear - to design a game that was not
        only fun and intriguing but also resonated with people like us, a group
        of close-knit friends. We envisioned an immersive experience that would
        provide players with real-life detective thrills, just like the mystery
        novels and TV shows we all enjoyed. With passion and dedication, we
        crafted Crime Unfolded to offer you a genuine detective experience,
        where you can unravel mysteries and solve intriguing murder cases. Our
        game brings friends and families together for an unforgettable time,
        filled with laughter, excitement, and the joy of collective
        problem-solving. We invite you to join us on this adventure, as we
        create lasting memories and celebrate the power of friendship through
        thrilling crime-solving escapades. Prepare to immerse yourself in the
        world of mysteries with Crime Unfolded - a place where fun, excitement,
        and cherished moments await you and your loved ones.
      </p>
    </div>
  );
};

export default About;
